export default {"src":"/_next/static/media/contribution4.d10eecb0.svg","height":100,"width":217,"blurWidth":0,"blurHeight":0};